import { render, staticRenderFns } from "./DecorationReplacement.vue?vue&type=template&id=e0bbaf0e&"
import script from "./DecorationReplacement.vue?vue&type=script&lang=js&"
export * from "./DecorationReplacement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports